import { Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider, RequireAuth } from "./auth";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { ScraperPage } from "./pages/ScraperPage";
import { OutputPage } from "./pages/OutputPage";
import { TaskPage } from "./pages/TaskPage";
import { ApiPage } from "./pages/ApiPage";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/scrapers" replace />} />
          <Route path="scrapers" element={<ScraperPage />} />
          <Route path="output" element={<OutputPage />} />
          <Route path="output/:taskId" element={<TaskPage />} />
          <Route path="api" element={<ApiPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
